import { PropsWithChildren } from 'react';
import type { ReactElement } from 'react';
import classNames from 'classnames';

export type Props = {
	img: string;
	cssClass?: string;
};

export default function BackgroundImage({
	img,
	cssClass = '',
	children,
}: PropsWithChildren<Props>): ReactElement {
	return (
		<div
			style={{
				backgroundImage: `url(${img})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center center',
			}}
			className={classNames('BackgroundImage lazyloaded', cssClass)}
		>
			{children}
		</div>
	);
}
